import React, { useEffect, useRef, useState } from "react";
import patient from "../../assets/img/patient.jpg";
import { useNavigate, useParams } from "react-router";
import {
  GET_ASSESMENT_DATA_REPORT,
  GET_ASSESMENT_DATA_REPORT_STREAM,
  GET_BACKGROUND_REPORT,
  GET_BACKGROUND_REPORT_STREAM,
  GET_CLINICAL_INTERVIEW,
  GET_CLINICAL_INTERVIEW_STREAM,
  GET_COLLATERAL_REPORT,
  GET_DIAGNOSE,
  GET_DIAGNOSE_STREAM,
  GET_FORMULATION,
  GET_FORMULATION_STREAM,
  GET_HISTORY_REPORT,
  GET_MENNTAL_STATUS_EXAMINATION,
  GET_MENNTAL_STATUS_EXAMINATION_STREAM,
  GET_PROMPTS,
  GET_RECOMMENDATION,
  GET_RECOMMENDATION_STREAM,
  GET_STANRADISED_ASSESSMENT,
  GET_STANRADISED_ASSESSMENT_STREAM,
  PATIENT_PAITENT_REPORT_API_URL,
  PATIENT_REPORT_API_URL,
} from "../../action/apiPath";
import { CallWithAuth } from "../../action/apiActions";
import MetadataSection from "./MetadataSection";
import moment from "moment";
import { marked } from "marked";
import TurndownService from "turndown";
// import ReactQuill from "react-quill";
import { LOADING_CAPTION, QUILL_FORMATS, QUILL_MODULES } from "../../util/constant";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { showToast, ToastContainer } from "../../util/toastHelper";
import {
  convertImageToBase64,
  reportDateDwonaloadDateFormat,
  safeMarkedWrapper,
} from "../../util/custom";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import { Editor } from "@tinymce/tinymce-react";
import { tinymceApiKey, tinymceConfig } from "../../util/tinymceConfig";
import logo from "../../assets/img/logo.svg";

import htmlToPdfMake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import Swal from "sweetalert2";

import withReactContent from "sweetalert2-react-content";
import {
  reactQuillformats,
  reactQuillmodules,
  stripTableTagsWithSpace,
} from "../../util/reactQuillConfig";
import fileDownload from "js-file-download";
import PromptEditor from "../../components/PromptEditor/Index";

const MySwal = withReactContent(Swal);

// Dynamically load fonts
pdfMake.vfs = {
  ...pdfMake.vfs,
  "Roboto-Regular.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Regular.ttf").default,
  "Roboto-Medium.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Medium.ttf").default,
  "Roboto-Italic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Italic.ttf").default,
  "Roboto-MediumItalic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-MediumItalic.ttf")
      .default,
};

// Define custom fonts
pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};
const PatientReportInformationPageReactQuill = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const turndownService = new TurndownService();

  const [fieldWithActiveMic, setFieldWithActiveMic] = useState('');
  const onMicChange = (field) => {
    setFieldWithActiveMic(field);
  };

  const [hasProfile, setHasProfile] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [reportPatientData, setReportPatientData] = useState(null);
  const [apiEndPoints, setApiendPoints] = useState([
    {
      endPoint: GET_COLLATERAL_REPORT,
      type: "Collateral Report",
      key: "collateral",
    },
    {
      endPoint: GET_BACKGROUND_REPORT_STREAM,
      type: "Background Information",
      key: "background_info",
      stream: true
    },
    {
      endPoint: GET_ASSESMENT_DATA_REPORT_STREAM,
      type: "Assessment Data Report",
      key: "assessment_data",
      stream: true
    },
    {
      endPoint: GET_MENNTAL_STATUS_EXAMINATION_STREAM,
      type: "Mental Status Examination",
      key: "mse",
      stream: true
    },
    {
      endPoint: GET_STANRADISED_ASSESSMENT_STREAM,
      type: "Standardised Assessment",
      key: "standardised_assessment",
      stream: true
    },
    {
      endPoint: GET_CLINICAL_INTERVIEW_STREAM,
      type: "Clinical Interview",
      key: "clinical_interviews",
      stream: true
    },
    {
      endPoint: GET_FORMULATION_STREAM,
      type: "formulation",
      key: "formulation",
      stream: true
    },
    {
      endPoint: GET_DIAGNOSE_STREAM,
      type: "DSM-5-TR/ICD-11 Diagnoses",
      key: "diagnose",
      stream: true
    },
    {
      endPoint: GET_RECOMMENDATION_STREAM,
      type: "Recommendations",
      key: "recommendation",
      stream: true
    },
  ]);

  const editorRef = useRef(null);

  const [reportgenerateData, setReportgenerateData] = useState({
    background_info: "",
    background_info_with_markdown: "",
    background_info_generated: false,
    background_info_generation_done: false,
    background_info_update_prompt: false,

    assessment_data: "",
    assessment_data_with_markdown: "",
    assessment_data_generated: false,
    assessment_data_generation_done: false,
    assessment_data_update_prompt: false,

    collateral: "",
    collateral_with_markdown: "",
    collateral_generated: false,
    collateral_generation_done: false,
    collateral_update_prompt: false,

    mse: "",
    mse_with_markdown: "",
    mse_generated: false,
    mse_generation_done: false,
    mse_update_prompt: false,

    standardised_assessment: "",
    standardised_assessment_with_markdown: "",
    standardised_assessment_generated: false,
    standardised_assessment_generation_done: false,
    standardised_assessment_update_prompt: false,

    clinical_interviews: "",
    clinical_interviews_with_markdown: "",
    clinical_interviews_generated: false,
    clinical_interviews_generation_done: false,
    clinical_interviews_update_prompt: false,

    formulation: "",
    formulation_with_markdown: "",
    formulation_generated: false,
    formulation_generation_done: false,
    formulation_update_prompt: false,

    diagnose: "",
    diagnose_with_markdown: "",
    diagnose_generated: false,
    diagnose_generation_done: false,
    diagnose_update_prompt: false,

    recommendation: "",
    recommendation_with_markdown: "",
    recommendation_generated: false,
    recommendation_generation_done: false,
    recommendation_update_prompt: false,
  });

  const [promptData, setPromptData] = useState({
    background_info: "background_info",
    assessment_data: "",
    collateral: "",
    mse: "",
    standardised_assessment: "",
    clinical_interviews: "",
    formulation: "",
    diagnose: "",
    recommendation: "",
  });

  const [promptResult, setPromptResult] = useState([]);

  const [currentPromptData, setCurrentPromptData] = useState({
    background_info: "",
    assessment_data: "",
    collateral: "",
    mse: "",
    standardised_assessment: "",
    clinical_interviews: "",
    formulation: "",
    diagnose: "",
    recommendation: "",
  });
  const [reportDisplayStatus, setReportDisplayStatus] = useState({
    background_info: false,
    assessment_data: false,
    history: false,
    collateral: false,
    mse: false,
    standardised_assessment: false,
    clinical_interviews: false,
    formulation: false,
    diagnose: false,
    recommendation: false,
  });
  const [getResults, setResults] = useState([]);
  const [cureentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isReportGenerate, setIsReportGenerate] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [isProptsApiCall, setIsProptsApiCall] = useState(false);

  const [checkreportAppoved, setCheckreportAppoved] = useState(true);

  const [isReportDownload, setIsReportDownload] = useState("");
  const [isReportDocDownload, setIsReportDocDownload] = useState("");
  const [isApprovedLoading, setIsApprovedLoading] = useState("");
  const [isReportApproved, setIsReportApproved] = useState(null);
  const isReportLimitReached = localStorage.getItem("isReportLimitReached");

  const [collateralGenerated, setCollateralGenerated] = useState(false);
  const [backgroundInfoGenerated, setBackgroundInfoGenerated] = useState(false);
  const [assessmentGenerated, setAssessmentGenerated] = useState(false);
  const [mentalStatusExaminationGenerated, setMentalStatusExaminationGenerated] = useState(false);
  const [standardisedAssessmentGenerated, setStandardisedAssessmentGenerated] = useState(false);
  const [clinicalInterviewsGenerated, setClinicalInterviewsGenerated] = useState(false);
  const [formulationGenerated, setFormulationGenerated] = useState(false);
  const [diagnoseGenerated, setDiagnoseGenerated] = useState(false);
  const [recommendationGenerated, setRecommendationGenerated] = useState(false);

  useEffect(() => {
    getPatientReportApiCall();
    getPatientReportRecordApiCall();
    getProptsDeatils();
    // getReportAlldetail();

    if (!localStorage.getItem("userCreateAccountInfo") || localStorage.getItem("userCreateAccountInfo") === "null") {
      setHasProfile(false);
    } else {
      setHasProfile(true)
    }
  }, []);

  useEffect(() => {
    if (hasProfile === false) {
      showToast("error", "Profile not set. Please setup your profile to continue");
    }
  }, [hasProfile]);

  useEffect(() => {
    if (reportGenerated) {
      setIsLoading(false);
    }
  }, [reportGenerated]);

  useEffect(() => {
    if (isProptsApiCall && !collateralGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "collateral")
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, collateralGenerated]);
  
  useEffect(() => {
    if (isProptsApiCall && collateralGenerated && !backgroundInfoGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "background_info")
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, collateralGenerated, backgroundInfoGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !assessmentGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "assessment_data");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, assessmentGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !mentalStatusExaminationGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "mse");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, mentalStatusExaminationGenerated]);

  useEffect(() => {console.log(clinicalInterviewsGenerated);
    if (isProptsApiCall && backgroundInfoGenerated && !clinicalInterviewsGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "clinical_interviews");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, clinicalInterviewsGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !formulationGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "formulation");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, formulationGenerated]);

  useEffect(() => {
    if (isProptsApiCall && assessmentGenerated && !standardisedAssessmentGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "standardised_assessment");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, assessmentGenerated, standardisedAssessmentGenerated]);

  useEffect(() => {
    if (
      isProptsApiCall && 
      backgroundInfoGenerated && 
      assessmentGenerated && 
      mentalStatusExaminationGenerated && 
      standardisedAssessmentGenerated && 
      clinicalInterviewsGenerated && 
      formulationGenerated && 
      !diagnoseGenerated && 
      !reportGenerated
    ) {
      let index = apiEndPoints.findIndex(item => item.key == "diagnose");
      getReportAlldetail(index);
    }
  }, [
    isProptsApiCall, 
    backgroundInfoGenerated, 
    assessmentGenerated, 
    mentalStatusExaminationGenerated, 
    standardisedAssessmentGenerated, 
    clinicalInterviewsGenerated, 
    formulationGenerated, 
    diagnoseGenerated
  ]);

  useEffect(() => {
    if (
      isProptsApiCall && 
      backgroundInfoGenerated && 
      assessmentGenerated && 
      mentalStatusExaminationGenerated && 
      standardisedAssessmentGenerated && 
      clinicalInterviewsGenerated && 
      formulationGenerated && 
      diagnoseGenerated && 
      !recommendationGenerated && 
      !reportGenerated
    ) {
      let index = apiEndPoints.findIndex(item => item.key == "recommendation");
      getReportAlldetail(index);
    }
  }, [
    isProptsApiCall, 
    backgroundInfoGenerated, 
    assessmentGenerated, 
    mentalStatusExaminationGenerated, 
    standardisedAssessmentGenerated, 
    clinicalInterviewsGenerated, 
    formulationGenerated, 
    diagnoseGenerated, 
    recommendationGenerated
  ]);

  const getProptsDeatils = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
      } else {
        setPromptResult([]);
        setIsProptsApiCall(true);
      }
    } catch (error) {
      setPromptResult([]);
      setIsProptsApiCall(true);
    }
  }

  const getPatientReportRecordApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_PAITENT_REPORT_API_URL}${id}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        // console.log('258===>',response.res.data.data);
        setCheckreportAppoved(false);
        setReportPatientData(response.res.data.data);
        if (response.res.data.data?.is_approved) {
          setReportgenerateData((pre) => ({
            ...pre,
            background_info: response?.res?.data?.data?.background_info,
            background_info_with_markdown: response?.res?.data?.data?.background_info ? marked(
              response?.res?.data?.data?.background_info
            ) : "",
            background_info_generated: true,
            background_info_generation_done: true,

            assessment_data: response?.res?.data?.data?.assessment_data,
            assessment_data_with_markdown: response?.res?.data?.data?.assessment_data ? marked(
              response?.res?.data?.data?.assessment_data
            ) : "",
            assessment_data_generated: true,
            assessment_data_generation_done: true,

            collateral: response?.res?.data?.data?.collateral,
            collateral_with_markdown: response?.res?.data?.data?.collateral ? marked(
              response?.res?.data?.data?.collateral
            ) : "",
            collateral_generated: true,
            collateral_generation_done: true,

            mse: response?.res?.data?.data?.mse,
            mse_with_markdown: response?.res?.data?.data?.mse ? marked(response?.res?.data?.data?.mse) : "",
            mse_generated: true,
            mse_generation_done: true,

            standardised_assessment:
              response?.res?.data?.data?.standardised_assessment,
            standardised_assessment_with_markdown: response?.res?.data?.data?.standardised_assessment ? marked(
              response?.res?.data?.data?.standardised_assessment
            ) : "",
            standardised_assessment_generated: true,
            standardised_assessment_generation_done: true,

            clinical_interviews: response?.res?.data?.data?.clinical_interviews,
            clinical_interviews_with_markdown: response?.res?.data?.data?.clinical_interviews ? marked(
              response?.res?.data?.data?.clinical_interviews
            ) : "",
            clinical_interviews_generated: true,
            clinical_interviews_generation_done: true,

            formulation: response?.res?.data?.data?.formulation,
            formulation_with_markdown: response?.res?.data?.data?.formulation ? marked(
              response?.res?.data?.data?.formulation
            ) : "",
            formulation_generated: true,
            formulation_generation_done: true,

            diagnose: response?.res?.data?.data?.diagnose,
            diagnose_with_markdown: response?.res?.data?.data?.diagnose ? marked(response?.res?.data?.data?.diagnose) : "",
            diagnose_generated: true,
            diagnose_generation_done: true,

            recommendation: response?.res?.data?.data?.recommendation,
            recommendation_with_markdown: response?.res?.data?.data?.recommendation ? marked(
              response?.res?.data?.data?.recommendation
            ) : "",
            recommendation_generated: true,
            recommendation_generation_done: true
          }));

          setIsReportGenerate(true);
          setReportGenerated(true);
          setIsReportApproved(true);
        } else {
          setIsReportApproved(false);
        }

      }
      
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  useEffect(() => {
    if (isReportApproved !== null) {
      if (!isReportApproved && isReportLimitReached) {
        showToast("error", "You have reached the limit for maximum number of reports");
      }
    }
  }, [isReportApproved, isReportLimitReached]);

  const getPatientReportApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_REPORT_API_URL}${id}/?extra=false`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setReportData(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  const streamCallWithAuth = async (url, body) => {
    const token = localStorage.getItem('accessToken'); // Or however you get your auth token
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body),
    });
  };

  const getReportAlldetail = async (_cureentIndex) => {
    try {
      if (apiEndPoints[_cureentIndex].endPoint != undefined) {
        const currentKey = apiEndPoints[_cureentIndex].key;
        const currentEndPoint = apiEndPoints[_cureentIndex].endPoint;
        const findPropmts = promptResult.find((item) => item.apiEndpointName === apiEndPoints[_cureentIndex].key);

        if (isReportLimitReached) {
          if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
            setIsReportGenerate(true);
          }

          setReportgenerateData((prev) => ({
            ...prev,
            [apiEndPoints[_cureentIndex].key]: 'You have reached the maximum number of reports allowed by your subscription plan. Please upgrade your plan or contact support for more information.',
            [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked('You have reached the maximum number of reports allowed by your subscription plan. Please upgrade your plan or contact support for more information.'),
            [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
            [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
          }));

          setIsLoading(false);

        } else if (findPropmts != undefined) {
          if (apiEndPoints[_cureentIndex].stream) {
            const response = await streamCallWithAuth(`${currentEndPoint}${id}`, { 
              prompt_text: findPropmts?.promtText 
            });
      
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let accumulatedText = "";
      
            // 2. Read the stream
            while (true) {
              const { value, done } = await reader.read();
      
              const chunk = decoder.decode(value, { stream: true });

              let resp = null;
              try {
                resp = JSON.parse(chunk);
              } catch (e) {}

              if (resp?.error) {
                if (accumulatedText.trim()) {
                  accumulatedText += "\n\n" + resp.message;
                } else {
                  accumulatedText = resp.message;
                }
                setReportgenerateData((prev) => ({
                  ...prev,
                  [apiEndPoints[_cureentIndex].key]: accumulatedText,
                  [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked(accumulatedText),
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: done,
                }));
              }

              if (done) {
                setReportgenerateData((prev) => ({
                  ...prev,
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: done,
                  [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
                }));
                break;
              }
              
              // 3. Parse SSE format (data: {"chunk": "..."})
              const lines = chunk.split("\n\n");
              lines.forEach(line => {
                if (line.startsWith("data: ")) {
                  try {
                    const data = JSON.parse(line.replace("data: ", ""));
                    
                    if (data.chunk) {
                      accumulatedText += data.chunk.replaceAll("data: ", "").replaceAll("\n\ndata: ", "").replace(/\n\n$/, '');
                      
                      // 4. Update state in real-time
                      setReportgenerateData((prev) => ({
                        ...prev,
                        [apiEndPoints[_cureentIndex].key]: accumulatedText,
                        [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked(accumulatedText),
                        [`${apiEndPoints[_cureentIndex].key}_generated`]: true
                      }));
                    }
                    
                    if (data.status === 'done') {
                      console.log("Streaming complete");
                    }
                  } catch (e) {
                    setReportgenerateData((prev) => ({
                      ...prev,
                      [apiEndPoints[_cureentIndex].key]: "Report Not Generated",
                      [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: "Report Not Generated",
                      [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                    }));
                    console.error("Error parsing stream chunk", e);
                  }
                }
              });
            }

            if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
              setIsReportGenerate(true);
            }
            
            // Move to next section after background info is finished
            setCurrentIndex(_cureentIndex + 1);

          } else {
            const response = await CallWithAuth(
              "POST",
              `${apiEndPoints[_cureentIndex].endPoint}${id}`,
              { prompt_text: findPropmts?.promtText }
            );
  
            if (response?.res?.data?.statusCode === 200) {
              if (
                apiEndPoints[_cureentIndex].endPoint === GET_BACKGROUND_REPORT &&
                response?.res?.data?.data?.is_approved
              ) {
                setReportgenerateData((pre) => ({
                  ...pre,
                  background_info: response?.res?.data?.data?.background_info,
                  background_info_with_markdown: response?.res?.data?.data?.background_info ? marked(
                    response?.res?.data?.data?.background_info
                  ) : "",
                  background_info_generated: true,
                  background_info_generation_done: true,
  
                  assessment_data: response?.res?.data?.data?.assessment_data,
                  assessment_data_with_markdown: response?.res?.data?.data?.assessment_data ? marked(
                    response?.res?.data?.data?.assessment_data
                  ) : "",
                  assessment_data_generated: true,
                  assessment_data_generation_done: true,
  
                  collateral: response?.res?.data?.data?.collateral,
                  collateral_with_markdown: response?.res?.data?.data?.collateral ? marked(
                    response?.res?.data?.data?.collateral
                  ) : "",
                  collateral_generated: true,
                  collateral_generation_done: true,
  
                  mse: response?.res?.data?.data?.mse,
                  mse_with_markdown: response?.res?.data?.data?.mse ? marked(response?.res?.data?.data?.mse) : "",
                  mse_generated: true,
                  mse_generation_done: true,
  
                  standardised_assessment:
                    response?.res?.data?.data?.standardised_assessment,
                  standardised_assessment_with_markdown: response?.res?.data?.data?.standardised_assessment ? marked(
                    response?.res?.data?.data?.standardised_assessment
                  ) : '',
                  standardised_assessment_generated: true,
                  standardised_assessment_generation_done: true,
  
                  clinical_interviews:
                    response?.res?.data?.data?.clinical_interviews,
                  clinical_interviews_with_markdown: response?.res?.data?.data?.clinical_interviews ? marked(
                    response?.res?.data?.data?.clinical_interviews
                  ) : '',
                  clinical_interviews_generated: true,
                  clinical_interviews_generation_done: true,
  
                  formulation: response?.res?.data?.data?.formulation,
                  formulation_with_markdown: response?.res?.data?.data?.formulation ? marked(
                    response?.res?.data?.data?.formulation
                  ) : '',
                  formulation_generated: true,
                  formulation_generation_done: true,
  
                  diagnose: response?.res?.data?.data?.diagnose,
                  diagnose_with_markdown: response?.res?.data?.data?.diagnose ? marked(
                    response?.res?.data?.data?.diagnose
                  ) : "",
                  diagnose_generated: true,
                  diagnose_generation_done: true,
  
                  recommendation: response?.res?.data?.data?.recommendation,
                  recommendation_with_markdown: response?.res?.data?.data?.recommendation ? marked(
                    response?.res?.data?.data?.diagnose
                  ) : "",
                  recommendation_generated: true,
                  recommendation_generation_done: true
                }));

                setIsReportGenerate(true);
                setReportGenerated(true);

              } else {  
                setReportgenerateData((prevResults) => ({
                  ...prevResults,
                  [apiEndPoints[_cureentIndex].key]:
                    response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key],
                  [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key] ? marked(
                    response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key]
                  ) : "Report Not Generated",
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                  [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
                }));
              }
  
              if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
                setIsReportGenerate(true);
              }
            } else {
              if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
                setIsReportGenerate(true);
              }
  
              setReportgenerateData((prevResults) => ({
                ...prevResults,
                [apiEndPoints[_cureentIndex].key]: response?.res?.data?.message,
                [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: response?.res?.data?.message,
                [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
              }));
            }
          }

          setCurrentIndex(_cureentIndex + 1);

        } else {
          if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
            setIsReportGenerate(true);
          }

          setReportgenerateData((prev) => ({
            ...prev,
            [apiEndPoints[_cureentIndex].key]: 'Prompt is missing',
            [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked('Prompt is missing'),
            [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
            [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
          }));

          setIsLoading(false);
        }

        if (currentKey == "collateral") {
          setCollateralGenerated(true);
        }
        else if (currentKey == "background_info") {
          setBackgroundInfoGenerated(true);
        }
        else if (currentKey == "assessment_data") {
          setAssessmentGenerated(true);
        }
        else if (currentKey == "mse") {
          setMentalStatusExaminationGenerated(true);
        }
        else if (currentKey == "standardised_assessment") {
          setStandardisedAssessmentGenerated(true);
        }
        else if (currentKey == "clinical_interviews") {
          setClinicalInterviewsGenerated(true);
        }
        else if (currentKey == "formulation") {
          setFormulationGenerated(true);
        }
        else if (currentKey == "diagnose") {
          setDiagnoseGenerated(true);
        }
        else if (currentKey == "recommendation") {
          setRecommendationGenerated(true);
        }

      }

    } catch (error) {}

    setIsLoading(false);
  };

  const handleEditorChange = (section, val) => {
    setTimeout(adjustHeight, 0); // Adjust height after rendering
    setReportDisplayStatus((prevResults) => ({
      ...prevResults,
      [section]: !val,
    }));
  };

  const handleChange = (fieldName, value) => {
    // Update state or perform any other actions based on fieldName and value
    console.log(fieldName, value); // 'background_info', the value from ReactQuill
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      // [fieldName]: turndownService.turndown(editorData),
      [fieldName]: value,
      [`${fieldName}_with_markdown`]: marked(value),
    }));
  };

  const handleApprove = async () => {
    const result = await MySwal.fire({
      title:
        "Are you sure you want to approve the report? Please download the report, as it will be deleted after 30 days.",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve report!",
    });
    if (result.isConfirmed) {
      try {
        setIsApprovedLoading(true);
        let obj = {
          background_info: stripTableTagsWithSpace(
            reportgenerateData.background_info
          ),
          collateral: stripTableTagsWithSpace(reportgenerateData.collateral),
          mse: stripTableTagsWithSpace(reportgenerateData.mse),
          standardised_assessment: stripTableTagsWithSpace(
            reportgenerateData.standardised_assessment
          ),
          clinical_interviews: stripTableTagsWithSpace(
            reportgenerateData.clinical_interviews
          ),
          history: stripTableTagsWithSpace(reportgenerateData.history),

          formulation: stripTableTagsWithSpace(reportgenerateData.formulation),
          diagnose: stripTableTagsWithSpace(reportgenerateData.diagnose),
          recommendation: stripTableTagsWithSpace(reportgenerateData.recommendation),
          assessment_data: stripTableTagsWithSpace(reportgenerateData.assessment_data),
          is_approved: true,
        };

        const response = await CallWithAuth(
          "PATCH",
          `${PATIENT_PAITENT_REPORT_API_URL}${id}`,
          obj
        );
        if (response?.res?.data?.statusCode === 200) {
          showToast("success", "Report has been saved successfully.");
          setReportGenerated(true);
        } else {
          showToast("error", response.res.data.message);
        }

        setIsApprovedLoading(false);

      } catch (error) {
        setIsApprovedLoading(false);
      }
    }
  };

  const handleDownloadPdf = async () => {
    setIsReportDownload(true);

    const formattedHtml = Object.entries(reportgenerateData)
      .filter(
        ([key]) =>
          !key.endsWith("_generated") && !key.endsWith("_generation_done") && !key.endsWith("_with_markdown") && !key.endsWith("_update_prompt")
      )
      .map(([key, value]) => {
        // Format key: Replace "_" with space and capitalize words
        let formattedKey = key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        console.log("formattedKey", formattedKey);

        // Replace "Diagnose" with "Impressions and Diagnosis"
        if (formattedKey != 'Collateral') {
          // Replace "Diagnose" with "Impressions and Diagnosis"
          if (formattedKey === "Diagnose") {
            formattedKey = "Impressions and Diagnosis";
          }
          if (formattedKey == 'Background Info') {
            formattedKey = "Background";
          }
          return `<h3>${formattedKey}</h3> ${value ? marked(value) : ""}`; // Add as HTML

        } else {
          return "";
        }
      })
      .join(" "); // Join all HTML
    let base64Logo = await convertImageToBase64(logo);

    const convertedContent = htmlToPdfMake(formattedHtml);
    const docDefinition = {
      pageSize: "A4", // Default is A4
      pageOrientation: "prtrait", // Set landscape mode
      content: [
        {
          image: base64Logo, // Insert the Base64 logo
          width: 100, // Adjust size
          alignment: "center", // Center align the logo
          margin: [0, 0, 0, 20], // Space below the logo
        },
        convertedContent, // Insert the formatted content
      ],
    };
    const fullName = reportData?.full_name
      ? reportData.full_name.replace(/\s+/g, "_")
      : "";

    const filename = reportData?.full_name
      ? `${fullName}_document_${reportDateDwonaloadDateFormat()}.pdf`
      : `document_${reportDateDwonaloadDateFormat()}.pdf`;

    // Now use pdfmake to generate PDF
    pdfMake.createPdf(docDefinition).download(filename);
    setIsReportDownload(false);
  };

  const handleDownloadDoc = async () => {
    setIsReportDocDownload(true);
    const formattedHtml = Object.entries(reportgenerateData)
      .filter(
        ([key]) =>
          !key.endsWith("_generated") && !key.endsWith("_generation_done") && !key.endsWith("_with_markdown") && !key.endsWith("_update_prompt")
      )
      .map(([key, value]) => {

        let formattedKey = key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        if (formattedKey != 'Collateral') {
          // Replace "Diagnose" with "Impressions and Diagnosis"
          if (formattedKey === "Diagnose") {
            formattedKey = "Impressions and Diagnosis";
          }
          if (formattedKey == 'Background Info') {
            formattedKey = "Background";
          }
          return `<h3>${formattedKey}</h3> ${value ? marked(value) : ""}`; // Add as HTML
        } else {
          return;
        }
        // return `<h3>${formattedKey}</h3> ${value}`; // Add as HTML
      })
      .join(" "); // Join all HTML
    let base64Logo = await convertImageToBase64(logo);

    const fullName = reportData?.full_name
      ? reportData.full_name.replace(/\s+/g, "_")
      : "";

    const filename = reportData?.full_name
      ? `${fullName}_document_${reportDateDwonaloadDateFormat()}.doc`
      : `document_${reportDateDwonaloadDateFormat()}.doc`;
    // Add logo to HTML using <img>
    const logo_section_html = `
<div style="text-align: center; margin-bottom: 20px;">
  <img src="${base64Logo}" alt="Logo" style="width: 150px; height: auto;" />
</div>`;

    // Convert HTML to Blob
    const blob = new Blob(
      [
        ` <html>
        <head>
          <meta charset="UTF-8">
          <title>Document</title>
        </head><body>${logo_section_html}${formattedHtml}</body>
      </html>`,
      ],
      { type: "application/msword" }
    );

    // Option 1: Use js-file-download (Optional)
    fileDownload(blob, filename);
    setIsReportDocDownload(false);
  };
  const textareaRef = useRef(null);

  // console.log("reportGenerated", reportGenerated);
  const adjustHeight = () => {
    if (textareaRef.current) {
      // textareaRef.current.style.height = '40px'; // Reset to initial height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  const handleTestPrompt = (reportData, field) => {
    console.log(reportData, field);
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      [field]: reportData,
      [`${field}_with_markdown`]: reportData ? marked(reportData) : "",
    }));

  };
  const handleUpdatePrompt = (reportData, field, promptValue, done) => {
    console.log("fieldName", reportData);
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      [field]: reportData,
      [`${field}_with_markdown`]: reportData ? marked(reportData) : "",
    }));
    if (done) {
      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${field}_update_prompt`]: false,
      }));
      getProptsDeatils();
    }
    // setPromptResult(prev =>
    //   prev.map(item =>
    //     item.apiEndpointName === field
    //       ? { ...item, promtText: promptValue }
    //       : item
    //   )
    // );
  }
  // console.log("promptResult======", promptResult);



  const handlePromptInputChange = (fieldName, value) => {
    setPromptData((prev) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
  }

  const handleChangePrompt = (fieldName, value) => {
    if (!value) {
      const findPropmts = promptResult.find((item) => item.apiEndpointName === fieldName);
      // console.log("findPropmts", findPropmts);     

      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: !value,
      }));
      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: findPropmts?.promtText,
      }));
      if (currentPromptData[fieldName] == '') {//check if the prompt is empty
        setCurrentPromptData((prevResults) => ({
          ...prevResults,
          // [fieldName]: promptData[fieldName],
          [fieldName]: findPropmts?.promtText,
          [`${fieldName}_previous_value`]: reportgenerateData[`${fieldName}`],
        }));
      }
    } else {
      /*setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: !value,
      }));*/
      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: !value,
        [`${fieldName}_with_markdown`]: marked(currentPromptData[`${fieldName}_previous_value`]),
        [`${fieldName}`]: currentPromptData[`${fieldName}_previous_value`],
      }));
      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: currentPromptData[fieldName],
      }));
      setCurrentPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: promptData[fieldName],
      }));
    }
  }
  const handleReset = async (fieldName, value) => {
    try {
      // setPromptResult(prev =>
      //   prev.map(item =>
      //     item.apiEndpointName === fieldName
      //       ? { ...item, promtText: promptValue }
      //       : item
      //   )
      // );
      // console.log("value", value?.promtText);
      // return;

      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: false,
      }));

      setCurrentPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: value?.promtText,
      }));

      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: value?.promtText,
      }));

      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        // console.log("response", response.res.data.data);
        let propmptsResult = response.res.data.data;
        setPromptResult(propmptsResult);
        /*const findPropmts = propmptsResult.find((item) => item.apiEndpointName === fieldName);
        const apiEndpintsD = apiEndPoints.find((item) => item.key === fieldName);        
        const responsePrompt = await CallWithAuth(
          "POST",
          `${apiEndpintsD?.endPoint}${id}`,
          {prompt_text:findPropmts?.promtText}
        );
        if (responsePrompt?.res?.data?.statusCode === 200) {
          // console.log("responsePrompt=====>", responsePrompt?.res?.data?.data[fieldName]);          
          setReportgenerateData((prevResults) => ({
            ...prevResults,
            [fieldName]:  responsePrompt?.res?.data?.data?.[`${fieldName}`],
            [`${fieldName}_with_markdown`]: responsePrompt?.res?.data?.data?.[`${fieldName}`] ?marked(responsePrompt?.res?.data?.data?.[`${fieldName}`]):"",
          }));
        }*/
      }
    } catch (error) {

    }

  }

  return (
    <div className="create_account_block patient-report-information-template">
      <div className="site_container">
        <div className="create_account_form">
          {/* {isLoading && (
          // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )} */}
          {/* <section class="site_hero patient_management_banner">
        <div class="site_container">
          <div class="site_row">
            <div class="txt_colm"></div>
            <div class="img_colm">
              <div class="img_block">
                <img src={patient} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section> */}

          {/* <div className="foralign max-60 mb-5"> */}
          {/* <div class="site_container text-center" style={{ padding: "20px" }}>
          <h3>CONFIDENTIAL PSYCHOLOGIST REPORT</h3>
          <h5>
            <strong>Name:</strong> {reportData?.full_name}
          </h5>
          <h5>
            <strong>Phone:</strong> {reportData?.phone}
          </h5>
          <h5>
            <strong>D.O.B:</strong>{" "}
            {moment(reportData?.dob).format("DD/MM/yyyy")}
          </h5>
          <h5>
            <strong>Date of Assessment:</strong>{" "}
            {moment(reportData?.created_at).format("DD/MM/yyyy")}
          </h5>
        </div> */}
          {/* </div> */}



          {!reportGenerated && (<>
            <div className="report-container-main px-0 pt-5"><p style={{ color: "red", fontWeight: "bold" }} className="text-center">Please note that while editing the report, don't change any special characters like **, ####, -, **, **,, or ###, as they are used purposefully.</p></div>
          </>)}
          {/* {reportData?.metadata && (
        <>
          <div style={{ textAlign: "center" }}>
            <h2>Metadata</h2>
          </div>
          <MetadataSection
            setReportData={setReportData}
            metadata={reportData.metadata}
          />
        </>
      )} */}

          {/* background info */}
          {reportgenerateData.mse_generated && <></>}
          {/* {JSON.stringify(reportDisplayStatus)} */}
          {/* {reportDisplayStatus?.background_info} */}
          <div className="report-container-main px-0">
            <h1>
              background{" "}
              {!reportgenerateData?.background_info_generation_done && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}
            </h1>
            <div
              className="report-container-child-cls"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {!reportDisplayStatus?.background_info && (
                <>
                  <div
                    style={{
                      fontSize: "20px",
                      padding: "24px",
                      background: "#F9FAFC",
                      borderRadius: "10px",
                      width: "100%",
                      color: isReportLimitReached && !isReportApproved ? "red" : ""
                    }}
                    className="form-group report-container-new"
                    // dangerouslySetInnerHTML={{
                    //   __html:
                    //     reportgenerateData.background_info_with_markdown ?? "",
                    //   // __html: stripTableTagsWithSpace(
                    //   //   reportgenerateData.background_info
                    //   // ),
                    // }}
                    dangerouslySetInnerHTML={{
                      __html: reportgenerateData?.background_info_generated
                        ? reportgenerateData?.background_info_with_markdown ?? ""
                        : LOADING_CAPTION,
                    }}
                  />
                  {!reportGenerated && !isReportLimitReached && (
                    <>
                      <div className={!reportgenerateData.background_info_update_prompt ? 'd-flex' : ""}>
                        {!reportgenerateData.background_info_update_prompt && (<>
                          <button
                            onClick={(e) =>
                              handleEditorChange(
                                "background_info",
                                reportDisplayStatus.background_info
                              )
                            }
                            disabled={!reportgenerateData?.background_info_generation_done}
                          >
                            Edit
                          </button>
                        </>
                        )}

                        {!reportgenerateData.background_info_update_prompt ? (
                          <button
                            onClick={(e) =>
                              handleChangePrompt(
                                "background_info",
                                reportgenerateData.background_info_update_prompt
                              )
                            }
                            disabled={!reportgenerateData?.background_info_generation_done}
                            className="ms-4"
                          >
                            Edit Prompts
                          </button>
                        ) : (
                          <>
                            <PromptEditor
                              field="background_info"
                              promptValue={promptData?.background_info || ""}
                              onChange={handlePromptInputChange}
                              onTest={handleTestPrompt}
                              onUpdate={handleUpdatePrompt}
                              onCancel={handleChangePrompt}
                              onReset={handleReset}
                              cancelValue={reportgenerateData.background_info_update_prompt}
                              promptResult={promptResult}
                              isMiceActive={fieldWithActiveMic == "background_info"}
                              onMicChange={onMicChange}
                            />
                          </>
                        )}

                      </div>
                    </>
                  )}
                </>
              )}

              {reportDisplayStatus?.background_info && (
                <>
                  <textarea
                    onInput={adjustHeight}
                    value={reportgenerateData.background_info ?? ""}
                    onChange={(e) =>
                      handleChange("background_info", e.target.value)
                    }
                    ref={textareaRef}
                    className="form-control pe-5"
                  />
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "background_info",
                        reportgenerateData.background_info
                      )
                    }
                    className="view-report-button"
                  >
                    View
                  </button>
                </>
              )}
            </div>
          </div>
          {/*End background info */}

          <div className="report-container-main px-0">
            <h1>
              assessment data{" "}
              {!reportgenerateData?.assessment_data_generation_done && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}
            </h1>
            <div
              className="report-container-child-cls"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {!reportDisplayStatus?.assessment_data && (
                <>
                  <div
                    style={{
                      fontSize: "20px",
                      padding: "24px",
                      background: "#F9FAFC",
                      borderRadius: "10px",
                      width: "100%",
                      color: isReportLimitReached && !isReportApproved ? "red" : ""
                    }}
                    className="form-group report-container-new"
                    // dangerouslySetInnerHTML={{
                    //   __html:
                    //     reportgenerateData.background_info_with_markdown ?? "",
                    //   // __html: stripTableTagsWithSpace(
                    //   //   reportgenerateData.background_info
                    //   // ),
                    // }}
                    dangerouslySetInnerHTML={{
                      __html: reportgenerateData?.assessment_data
                        ? reportgenerateData?.assessment_data_with_markdown ?? ""
                        : LOADING_CAPTION,
                    }}
                  />
                  {!reportGenerated && !isReportLimitReached && (
                    <>
                      <div className={!reportgenerateData.assessment_data_update_prompt ? 'd-flex' : ""}>
                        {!reportgenerateData.assessment_data_update_prompt && (<>
                          <button
                            onClick={(e) =>
                              handleEditorChange(
                                "assessment_data",
                                reportDisplayStatus.assessment_data
                              )
                            }
                            disabled={!reportgenerateData?.assessment_data_generation_done}
                          >
                            Edit
                          </button>
                        </>
                        )}

                        {!reportgenerateData.assessment_data_update_prompt ? (
                          <button
                            onClick={(e) =>
                              handleChangePrompt(
                                "assessment_data",
                                reportgenerateData.assessment_data_update_prompt
                              )
                            }
                            disabled={!reportgenerateData?.assessment_data_generation_done}
                            className="ms-4"
                          >
                            Edit Prompts
                          </button>
                        ) : (
                          <>
                            <PromptEditor
                              field="assessment_data"
                              promptValue={promptData?.assessment_data || ""}
                              onChange={handlePromptInputChange}
                              onTest={handleTestPrompt}
                              onUpdate={handleUpdatePrompt}
                              onCancel={handleChangePrompt}
                              onReset={handleReset}
                              cancelValue={reportgenerateData.assessment_data_update_prompt}
                              promptResult={promptResult}
                              isMiceActive={fieldWithActiveMic == "assessment_data"}
                              onMicChange={onMicChange}
                            />
                          </>
                        )}

                      </div>
                    </>
                  )}
                </>
              )}

              {reportDisplayStatus?.assessment_data && (
                <>
                  <textarea
                    onInput={adjustHeight}
                    value={reportgenerateData.assessment_data ?? ""}
                    onChange={(e) =>
                      handleChange("assessment_data", e.target.value)
                    }
                    ref={textareaRef}
                    className="form-control pe-5"
                  />
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "assessment_data",
                        reportgenerateData.assessment_data
                      )
                    }
                    className="view-report-button"
                  >
                    View
                  </button>
                </>
              )}
            </div>
          </div>


          {/* collateral info */}
          {/* <div className="report-container-main px-0">
        <h1>
          collateral{" "}
          {!reportgenerateData?.collateral_generated && (
            <>
              {""}
              <LoaderIndex />
            </>
          )}
        </h1> 
        <div
          className="report-container-child-cls"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          {!reportDisplayStatus?.collateral && (
            <>
              <div
                style={{
                  fontSize: "20px",
                  padding: "15px",
               background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                }}
                className="form-group report-container-new"
                // dangerouslySetInnerHTML={{
                //   __html: reportgenerateData.collateral_with_markdown ?? "",
                // }}
                dangerouslySetInnerHTML={{
                  __html: reportgenerateData?.collateral_generated
                    ? reportgenerateData?.collateral_with_markdown ?? ""
                    : LOADING_CAPTION,
                }}
              />
              {!reportGenerated && (
                <>
                  <div className={!reportgenerateData.collateral_update_prompt?'d-flex':""}>
                    {!reportgenerateData.collateral_update_prompt && ( <>
                      <button
                        onClick={(e) =>
                          handleEditorChange(
                            "collateral",
                            reportDisplayStatus.collateral
                          )
                        }
                        disabled={!reportgenerateData?.collateral_generated}
                      >
                        Edit
                      </button>                    
                    </>
                  )}
                    
                    {!reportgenerateData.collateral_update_prompt ? (
                      <button
                        onClick={(e) =>
                          handleChangePrompt(
                            "collateral",
                            reportgenerateData.collateral_update_prompt
                          )
                        }
                        disabled={!reportgenerateData?.collateral_generated}
                        className="ms-4"
                      >
                        Edit Prompts
                      </button>
                    ) : (  
                      <>
                        <PromptEditor
                          field="collateral"
                          promptValue={promptData?.collateral || ""}
                          onChange={handlePromptInputChange}
                          onTest={handleTestPrompt}
                          onUpdate={handleUpdatePrompt}
                          onCancel={handleChangePrompt}
                          onReset={handleReset}
                          cancelValue={reportgenerateData.collateral_update_prompt}
                          promptResult={promptResult}
                        />
                      </>
                    )}
                    
                  </div>
                </>
              )}
            </>
          )}

          {reportDisplayStatus?.collateral && (
            <>
              <textarea
                onInput={adjustHeight}
                value={reportgenerateData.collateral ?? ""}
                onChange={(e) => handleChange("collateral", e.target.value)}
                ref={textareaRef}
                className="form-control pe-5"
              />
              <button
                onClick={(e) =>
                  handleEditorChange(
                    "collateral",
                    reportgenerateData.collateral
                  )
                }
                className="view-report-button"
              >
                View
              </button>
            </>
          )}
        </div> 
      </div> */}

          {/* Edit collateral info */}

          {/* Mental Status Examination info */}

          {/* {reportgenerateData.mse_generated && ( */}
          <>
            <div className="report-container-main px-0">
              <h1>
                Mental Status Examination{" "}
                {!reportgenerateData?.mse_generation_done && (
                  <>
                    {""}
                    <LoaderIndex />
                  </>
                )}{" "}
              </h1>
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.mse && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      // dangerouslySetInnerHTML={{
                      //   __html: reportgenerateData.mse_with_markdown ?? "",
                      // }}
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.mse_generated
                          ? reportgenerateData?.mse_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />

                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.mse_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.mse_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "mse",
                                  reportDisplayStatus.mse
                                )
                              }
                              disabled={!reportgenerateData?.mse_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.mse_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "mse",
                                  reportgenerateData.mse_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.mse_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="mse"
                                promptValue={promptData?.mse || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.mse_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "mse"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.mse && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.mse ?? ""}
                      onChange={(e) => handleChange("mse", e.target.value)}
                      ref={textareaRef}
                      className="form-control pe-5"
                    />
                    {/* <ReactQuill
                  // value={marked(reportgenerateData.mse)}
                  value={stripTableTagsWithSpace(reportgenerateData.mse)}
                  // You can use 'snow', 'bubble', or other themes
                  onChange={(value) => handleChange("mse", value)} // Add param to handleChange
                  formats={reactQuillformats}
                  modules={reactQuillmodules}
                /> */}
                    {/* <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorMseContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorMseContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorMseContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      mse: editorMseContent,
                    }));
                    handleChange("mse", editorMseContent);
                  }}
                /> */}
                    <button
                      onClick={(e) =>
                        handleEditorChange("mse", reportgenerateData.mse)
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
          {/* )} */}

          {/* End Mental Status Examination info */}

          {/* standardised assessment info */}
          {/* {reportgenerateData.standardised_assessment_generated && ( */}
          <>
            <div className="report-container-main px-0">
              <h1>
                standardised assessment{" "}
                {!reportgenerateData?.standardised_assessment_generation_done && (
                  <>
                    {""}
                    <LoaderIndex />
                  </>
                )}{" "}
              </h1>
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.standardised_assessment && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      // dangerouslySetInnerHTML={{
                      //   __html:
                      //     reportgenerateData.standardised_assessment_with_markdown,
                      // }}
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.standardised_assessment_generated
                          ? reportgenerateData?.standardised_assessment_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {/* {!reportGenerated && (
                  <>
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "standardised_assessment",
                          reportDisplayStatus.standardised_assessment
                        )
                      }
                      disabled={
                        !reportgenerateData?.standardised_assessment_generated
                      }
                    >
                      Edit
                    </button>
                  </>
                )} */}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.standardised_assessment_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.standardised_assessment_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "standardised_assessment",
                                  reportDisplayStatus.standardised_assessment
                                )
                              }
                              disabled={!reportgenerateData?.standardised_assessment_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.standardised_assessment_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "standardised_assessment",
                                  reportgenerateData.standardised_assessment_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.standardised_assessment_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="standardised_assessment"
                                promptValue={promptData?.standardised_assessment || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.standardised_assessment_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "standardised_assessment"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.standardised_assessment && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.standardised_assessment ?? ""}
                      onChange={(e) =>
                        handleChange("standardised_assessment", e.target.value)
                      }
                      ref={textareaRef}
                      className="form-control pe-5"
                    />
                    {/* <ReactQuill
                  value={stripTableTagsWithSpace(
                    reportgenerateData.standardised_assessment
                  )}
                  onChange={(value) =>
                    handleChange("standardised_assessment", value)
                  } // Add param to handleChange
                /> */}
                    {/* <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorMseContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorStandardisedContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorStandardisedContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      standardised_assessment: editorStandardisedContent,
                    }));
                    handleChange(
                      "standardised_assessment",
                      editorStandardisedContent
                    );
                  }}
                /> */}

                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "standardised_assessment",
                          reportgenerateData.standardised_assessment
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
          {/* )} */}
          {/* end standardised assessment */}

          {/* clinical_interview info */}
          {/* {reportgenerateData?.clinical_interviews_generated && ( */}
          <>
            <div className="report-container-main px-0">
              <h1>
                clinical interviews{" "}
                {!reportgenerateData?.clinical_interviews_generation_done && (
                  <>
                    {""}
                    <LoaderIndex />
                  </>
                )}{" "}
              </h1>
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.clinical_interviews && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      // dangerouslySetInnerHTML={{
                      //   __html:
                      //     reportgenerateData.clinical_interviews_with_markdown,
                      // }}
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.clinical_interviews_generated
                          ? reportgenerateData?.clinical_interviews_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {/* {!reportGenerated && (
                  <>
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "clinical_interviews",
                          reportDisplayStatus.clinical_interviews
                        )
                      }
                      disabled={
                        !reportgenerateData?.clinical_interviews_generated
                      }
                    >
                      Edit
                    </button>
                  </>
                )} */}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.clinical_interviews_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.clinical_interviews_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "clinical_interviews",
                                  reportDisplayStatus.clinical_interviews
                                )
                              }
                              disabled={!reportgenerateData?.clinical_interviews_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.clinical_interviews_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "clinical_interviews",
                                  reportgenerateData.clinical_interviews_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.clinical_interviews_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="clinical_interviews"
                                promptValue={promptData?.clinical_interviews || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.clinical_interviews_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "clinical_interviews"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.clinical_interviews && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.clinical_interviews ?? ""}
                      onChange={(e) =>
                        handleChange("clinical_interviews", e.target.value)
                      }
                      ref={textareaRef}
                      className="form-control pe-5"
                    />
                    {/* <ReactQuill
                  // value={marked(reportgenerateData.clinical_interviews)}
                  value={stripTableTagsWithSpace(
                    reportgenerateData.clinical_interviews
                  )}
                  onChange={(value) =>
                    handleChange("clinical_interviews", value)
                  } // Add param to handleChange
                /> */}
                    {/* <Editor
                  apiKey={tinymceApiKey}
                  onInit={(evt, editor) => {
                    editorRef.current = editor;
                    editor.setContent(editorClinicalInterviewsContent); // Set initial content
                  }}
                  init={tinymceConfig}
                  value={editorClinicalInterviewsContent} // Use local state to prevent cursor jump
                  onEditorChange={(value) => {
                    setEditorClinicalInterviewsContent(value);
                  }}
                  onBlur={() => {
                    setReportgenerateData((prevData) => ({
                      ...prevData,
                      clinical_interviews: editorClinicalInterviewsContent,
                    }));
                    handleChange(
                      "clinical_interviews",
                      editorClinicalInterviewsContent
                    );
                  }}
                /> */}
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "clinical_interviews",
                          reportgenerateData.clinical_interviews
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
          {/* )} */}
          {/* end clinical_interviews  */}

          {/* formulation */}

          {/* formulation start here */}
          <div className="report-container-main px-0">
            <h1>
              formulation{" "}
              {!reportgenerateData?.formulation_generation_done && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}{" "}
            </h1>
            <div
              className="report-container-child-cls"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {!reportDisplayStatus?.formulation && (
                <>
                  <div
                    style={{
                      fontSize: "20px",
                      padding: "24px",
                      background: "#F9FAFC",
                      borderRadius: "10px",
                      width: "100%",
                      color: isReportLimitReached && !isReportApproved ? "red" : ""
                    }}
                    className="form-group report-container-new"
                    // dangerouslySetInnerHTML={{
                    //   __html: reportgenerateData.formulation_with_markdown,
                    // }}
                    dangerouslySetInnerHTML={{
                      __html: reportgenerateData?.formulation_generated
                        ? reportgenerateData?.formulation_with_markdown ?? ""
                        : LOADING_CAPTION,
                    }}
                  />
                  {/* {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "formulation",
                        reportDisplayStatus.formulation
                      )
                    }
                    disabled={!reportgenerateData?.formulation_generated}
                  >
                    Edit
                  </button>
                </>
              )} */}
                  {!reportGenerated && !isReportLimitReached && (
                    <>
                      <div className={!reportgenerateData.formulation_update_prompt ? 'd-flex' : ""}>
                        {!reportgenerateData.formulation_update_prompt && (<>
                          <button
                            onClick={(e) =>
                              handleEditorChange(
                                "formulation",
                                reportDisplayStatus.formulation
                              )
                            }
                            disabled={!reportgenerateData?.formulation_generation_done}
                          >
                            Edit
                          </button>
                        </>
                        )}

                        {!reportgenerateData.formulation_update_prompt ? (
                          <button
                            onClick={(e) =>
                              handleChangePrompt(
                                "formulation",
                                reportgenerateData.formulation_update_prompt
                              )
                            }
                            disabled={!reportgenerateData?.formulation_generation_done}
                            className="ms-4"
                          >
                            Edit Prompts
                          </button>
                        ) : (
                          <>
                            <PromptEditor
                              field="formulation"
                              promptValue={promptData?.formulation || ""}
                              onChange={handlePromptInputChange}
                              onTest={handleTestPrompt}
                              onUpdate={handleUpdatePrompt}
                              onCancel={handleChangePrompt}
                              onReset={handleReset}
                              cancelValue={reportgenerateData.formulation_update_prompt}
                              promptResult={promptResult}
                              isMiceActive={fieldWithActiveMic == "formulation"}
                              onMicChange={onMicChange}
                            />
                          </>
                        )}

                      </div>
                    </>
                  )}
                </>
              )}

              {reportDisplayStatus?.formulation && (
                <>
                  <textarea
                    onInput={adjustHeight}
                    value={reportgenerateData.formulation ?? ""}
                    onChange={(e) => handleChange("formulation", e.target.value)}
                    ref={textareaRef}
                    className="form-control pe-5"
                  />
                  {/* <ReactQuill
                // value={marked(reportgenerateData.formulation)}
                value={stripTableTagsWithSpace(reportgenerateData.formulation)}
                onChange={(value) => handleChange("formulation", value)} // Add param to handleChange
              /> */}
                  {/* <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorFormulationContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorFormulationContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorFormulationContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    formulation: editorFormulationContent,
                  }));
                  handleChange("formulation", editorFormulationContent);
                }}
              /> */}
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "formulation",
                        reportgenerateData.formulation
                      )
                    }
                    className="view-report-button"
                  >
                    View
                  </button>
                </>
              )}
            </div>
          </div>
          {/* end formulation */}

          {/* diagnose start here */}
          <div className="report-container-main px-0">
            <h1>
              Impressions and Diagnosis{" "}
              {!reportgenerateData?.diagnose_generation_done && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}{" "}
            </h1>
            <div
              className="report-container-child-cls"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {!reportDisplayStatus?.diagnose && (
                <>
                  <div
                    style={{
                      fontSize: "20px",
                      padding: "24px",
                      background: "#F9FAFC",
                      borderRadius: "10px",
                      width: "100%",
                      color: isReportLimitReached && !isReportApproved ? "red" : ""
                    }}
                    className="form-group report-container-new"
                    // dangerouslySetInnerHTML={{
                    //   __html: reportgenerateData.diagnose_with_markdown,
                    // }}
                    dangerouslySetInnerHTML={{
                      __html: reportgenerateData?.diagnose_generated
                        ? reportgenerateData?.diagnose_with_markdown ?? ""
                        : LOADING_CAPTION,
                    }}
                  />
                  {/* {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "diagnose",
                        reportDisplayStatus.diagnose
                      )
                    }
                    disabled={!reportgenerateData?.diagnose_generated}
                  >
                    Edit
                  </button>
                </>
              )} */}
                  {!reportGenerated && !isReportLimitReached && (
                    <>
                      <div className={!reportgenerateData.diagnose_update_prompt ? 'd-flex' : ""}>
                        {!reportgenerateData.diagnose_update_prompt && (<>
                          <button
                            onClick={(e) =>
                              handleEditorChange(
                                "diagnose",
                                reportDisplayStatus.diagnose
                              )
                            }
                            disabled={!reportgenerateData?.diagnose_generation_done}
                          >
                            Edit
                          </button>
                        </>
                        )}

                        {!reportgenerateData.diagnose_update_prompt ? (
                          <button
                            onClick={(e) =>
                              handleChangePrompt(
                                "diagnose",
                                reportgenerateData.diagnose_update_prompt
                              )
                            }
                            disabled={!reportgenerateData?.diagnose_generation_done}
                            className="ms-4"
                          >
                            Edit Prompts
                          </button>
                        ) : (
                          <>
                            <PromptEditor
                              field="diagnose"
                              promptValue={promptData?.diagnose || ""}
                              onChange={handlePromptInputChange}
                              onTest={handleTestPrompt}
                              onUpdate={handleUpdatePrompt}
                              onCancel={handleChangePrompt}
                              onReset={handleReset}
                              cancelValue={reportgenerateData.diagnose_update_prompt}
                              promptResult={promptResult}
                              isMiceActive={fieldWithActiveMic == "diagnose"}
                              onMicChange={onMicChange}
                            />
                          </>
                        )}

                      </div>
                    </>
                  )}
                </>
              )}

              {reportDisplayStatus?.diagnose && (
                <>
                  <textarea
                    onInput={adjustHeight}
                    value={reportgenerateData.diagnose ?? ""}
                    onChange={(e) => handleChange("diagnose", e.target.value)}
                    ref={textareaRef}
                    className="form-control pe-5"
                  />
                  {/* <ReactQuill
                // value={marked(reportgenerateData.diagnose)}
                value={stripTableTagsWithSpace(reportgenerateData.diagnose)}
                onChange={(value) => handleChange("diagnose", value)} // Add param to handleChange
              /> */}
                  {/* <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorDiagnoseContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorDiagnoseContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorDiagnoseContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    diagnose: editorDiagnoseContent,
                  }));
                  handleChange("diagnose", editorDiagnoseContent);
                }}
              /> */}
                  <button
                    onClick={(e) =>
                      handleEditorChange("diagnose", reportgenerateData.diagnose)
                    }
                    className="view-report-button"
                  >
                    View
                  </button>
                </>
              )}
            </div>
          </div>
          {/* end diagnose */}

          {/* recommendation start here */}
          <div className="report-container-main px-0">
            <h1>
              recommendation{" "}
              {!reportgenerateData?.recommendation_generation_done && (
                <>
                  {""}
                  <LoaderIndex />
                </>
              )}{" "}
            </h1>
            <div
              className="report-container-child-cls"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              {!reportDisplayStatus?.recommendation && (
                <>
                  <div
                    className="form-group report-container-new"
                    style={{
                      fontSize: "20px",
                      padding: "24px",
                      background: "#F9FAFC",
                      borderRadius: "10px",
                      width: "100%",
                      color: isReportLimitReached && !isReportApproved ? "red" : ""
                    }}
                    // className="form-group report-container-new"
                    // dangerouslySetInnerHTML={{
                    //   __html: reportgenerateData.recommendation_with_markdown,
                    // }}
                    dangerouslySetInnerHTML={{
                      __html: reportgenerateData?.recommendation_generated
                        ? reportgenerateData?.recommendation_with_markdown ?? ""
                        : LOADING_CAPTION,
                    }}
                  />
                  {/* {!reportGenerated && (
                <>
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "recommendation",
                        reportDisplayStatus.recommendation
                      )
                    }
                    disabled={!reportgenerateData?.recommendation_generated}
                  >
                    Edit
                  </button>
                </>
              )} */}
                  {!reportGenerated && !isReportLimitReached && (
                    <>
                      <div className={!reportgenerateData.recommendation_update_prompt ? 'd-flex mt-2' : "mt-2"}>
                        {!reportgenerateData.recommendation_update_prompt && (<>
                          <button
                            onClick={(e) =>
                              handleEditorChange(
                                "recommendation",
                                reportDisplayStatus.recommendation
                              )
                            }
                            disabled={!reportgenerateData?.recommendation_generation_done}
                          >
                            Edit
                          </button>
                        </>
                        )}

                        {!reportgenerateData.recommendation_update_prompt ? (
                          <button
                            onClick={(e) =>
                              handleChangePrompt(
                                "recommendation",
                                reportgenerateData.recommendation_update_prompt
                              )
                            }
                            disabled={!reportgenerateData?.recommendation_generation_done}
                            className="ms-4"
                          >
                            Edit Prompts
                          </button>
                        ) : (
                          <>
                            <PromptEditor
                              field="recommendation"
                              promptValue={promptData?.recommendation || ""}
                              onChange={handlePromptInputChange}
                              onTest={handleTestPrompt}
                              onUpdate={handleUpdatePrompt}
                              onCancel={handleChangePrompt}
                              onReset={handleReset}
                              cancelValue={reportgenerateData.recommendation_update_prompt}
                              promptResult={promptResult}
                              isMiceActive={fieldWithActiveMic == "recommendation"}
                              onMicChange={onMicChange}
                            />
                          </>
                        )}

                      </div>
                    </>
                  )}
                </>
              )}

              {reportDisplayStatus?.recommendation && (
                <>
                  <textarea
                    onInput={adjustHeight}
                    value={reportgenerateData.recommendation ?? ""}
                    onChange={(e) => handleChange("recommendation", e.target.value)}
                    ref={textareaRef}
                    className="form-control pe-5"
                  />
                  {/* <ReactQuill
                // value={marked(reportgenerateData.recommendation)}
                value={stripTableTagsWithSpace(
                  reportgenerateData.recommendation
                )}
                onChange={(value) => handleChange("recommendation", value)} // Add param to handleChange
                // formats={[
                //   "bold",
                //   "italic",
                //   "underline",
                //   "strike",
                //   "blockquote",
                //   "list",
                //   "bullet",
                //   "indent",
                //   "link",
                //   "image",
                //   "header",
                //   "font",
                //   "align",
                //   "size",
                //   "color",
                //   "background",
                //   "code-block",
                //   "table",
                // ]}
                // modules={{
                //   toolbar: [
                //     [{ header: "1" }, { header: "2" }, { font: [] }],
                //     [{ list: "ordered" }, { list: "bullet" }],
                //     ["bold", "italic", "underline"],
                //     [{ align: [] }],
                //     ["blockquote", "code-block"],
                //   ],
                // }}
              /> */}

                  {/* <Editor
                apiKey={tinymceApiKey}
                onInit={(evt, editor) => {
                  editorRef.current = editor;
                  editor.setContent(editorRecommendationContent); // Set initial content
                }}
                init={tinymceConfig}
                value={editorRecommendationContent} // Use local state to prevent cursor jump
                onEditorChange={(value) => {
                  setEditorRecommendationContent(value);
                }}
                onBlur={() => {
                  setReportgenerateData((prevData) => ({
                    ...prevData,
                    recommendation: editorRecommendationContent,
                  }));
                  handleChange("recommendation", editorRecommendationContent);
                }}
              /> */}
                  <button
                    onClick={(e) =>
                      handleEditorChange(
                        "recommendation",
                        reportgenerateData.recommendation
                      )
                    }
                    className="view-report-button"
                  >
                    View
                  </button>
                </>
              )}
            </div>
          </div>
          {/* end recommendation */}
          <>
            {hasProfile && isReportGenerate && !reportGenerated && !isReportLimitReached && (
              <div>
                <button
                  onClick={handleApprove}
                  disabled={isApprovedLoading}
                  className="approve-report-button"
                >
                  Approve{" "}
                  {isApprovedLoading && (
                    <>
                      {""}
                      <LoaderIndex />
                    </>
                  )}{" "}
                </button>
              </div>
            )}
          </>
          {isLoading && (
            <>
              <div className="full-page-loader">
                <div className="loader"></div>
              </div>
            </>
          )}
          
          {reportGenerated && (
            <>
              <div className="d-flex" style={{ marginBottom: "20px" }}>
                <button
                  onClick={handleDownloadPdf}
                  className="approve-report-button"
                  disabled={isReportDownload}
                >
                  Download as PDF Report{" "}
                  {isReportDownload && (
                    <>
                      {""}
                      <LoaderIndex />
                    </>
                  )}
                </button>
                <button
                  onClick={handleDownloadDoc}
                  className="approve-report-button"
                  disabled={isReportDocDownload}
                >
                  Download as Doc Report{" "}
                  {isReportDocDownload && (
                    <>
                      {""}
                      <LoaderIndex />
                    </>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientReportInformationPageReactQuill;
